export default class StripeLoader {

	constructor() {
		this.API_KEY = false;
		this.load();
	}

	load() {
		if (!this.isLoaded()) {
			// Inject facebook api
			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				/* js.src = 'https://js.stripe.com/v3/'; */ // added to main.js https://stripe.com/docs/stripe-js/reference#including-stripejs
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'stripe-sdk'));
		}

		if (window.konfig.stripeKey) {
			this.interval = setInterval(() => {
				if (this.isLoaded()) {
					/* this.API.setPublishableKey(window.konfig.stripeKey); */ // deprecated
					this.API_KEY = window.konfig.stripeKey;
					clearInterval(this.interval);
				}
			}, 100);
		}
	}

	isLoaded() {
		return (typeof this.API_KEY !== 'boolean');
	}

	getAPIKey() {
		return this.API_KEY;
	}

	get API() {
		return window.Stripe;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/stripe.js
 **/